var _desc, _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoryCounter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "85px",
    viewBox: "0 0 80 85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/storyCounter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "storyBackground",
    transform: "translate(-282.000000, -86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "storyCounter",
    transform: "translate(283.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9163636,9.60756204 C33.1563636,5.71665295 44.5563636,6.33483477 50.9054545,8.23301659 C59.0109199,10.9901925 64.9644608,15.3660844 69.0743242,20.5275581 L71.0994318,17.6303461 C72.0147372,18.9744512 75.0456321,24.9316601 75.5534446,26.9710777 C76.0612571,29.0104953 76.793679,33.9668284 76.793679,36.7535706 C76.793679,38.7040329 76.6789501,40.493602 76.4673881,42.1992061 C76.4971757,49.2479613 74.7237949,56.8069742 69.9527273,64.916653 C64.2872727,74.9130166 53.1710087,80.2937145 42.3346451,81.54826 C22.8073724,85.4137145 3.09730114,69.0039257 1.18181818,49.367562 C-2.48,32.447562 9.43272727,15.6657439 24.9163636,9.60756204 Z",
    id: "Combined-Shape",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#000000",
    opacity: 0.2,
    style: {
      mixBlendMode: "darken"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9054545,2.22909091 C44.5563636,0.330909091 33.1563636,-0.287272727 24.9163636,3.60363636 C9.43272727,9.66181818 -2.48,26.4436364 1.18181818,43.3636364 C3.09730114,63 22.8073724,79.4097889 42.3346451,75.5443343 C53.1710087,74.2897889 64.2872727,68.9090909 69.9527273,58.9127273 C75.4105942,49.6356534 76.9456175,41.0791937 76.3458807,33.1818182 C75.4105942,20.8659006 67.8729928,8.00081224 50.9054545,2.22909091 Z",
    id: "STROKE_3b41c18f-5c57-4e76-b696-1a3e6ef9a18c",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#586993"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(38.990159, 39.214202) rotate(24.000000) translate(-38.990159, -39.214202) translate(9.490159, 9.714202)",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8961834,0.339513864 C25.0671881,-1.44183089 12.5904836,3.9143489 5.75632209,13.4040582 C-4.45340044,27.9098724 -1.17333505,50.3791074 17.5396456,56.2008659 C38.7147513,65.0104254 62.2398785,42.8043437 57.6685469,21.7885241 C55.3725011,11.9061092 46.5370845,3.42043059 36.9086393,0.331416842",
    id: "STROKE_28f61f43-c965-45e8-9d68-e7ecc4264e98",
    stroke: "#435070",
    fill: "#6477A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3533038,57.116042 C14.3642102,56.0531869 8.80987781,51.744238 6.64901134,49.3546784 C0.435018705,41.5874433 -1.69477258,31.7641481 1.41818747,22.456596 C3.35621485,15.5479416 6.89287773,10.3497108 12.9956022,5.96938009 C19.0983268,1.58904941 24.6277045,-2.06703341e-14 32.7056025,-2.06703341e-14",
    id: "STROKE_cefaf9a6-f5f2-4003-8036-13bb4891d9a4",
    stroke: "#8697C0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4776278,75.522017 C42.1430824,77.3401989 53.5927273,74.6218182 63.2290909,67.5418182 C68.32,63.8690909 71.0509091,59.32 73.5781818,53.7236364 C75.4945455,47.8727273 76.793679,43.1312145 76.793679,36.5678267 C76.793679,33.7810846 76.0612571,28.8247514 75.5534446,26.7853338 C75.0456321,24.7459162 72.0147372,18.7887074 71.0994318,17.4446023",
    id: "STROKE_307cf84a-6fbd-481b-b8c3-aaf2e1d8f7f9",
    stroke: "#000000",
    strokeWidth: 2.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryCounter);
export default __webpack_public_path__ + "static/media/storyCounter.54e0b8cf7618ffd879d7ebd50c2566c6.svg";
export { ForwardRef as ReactComponent };